import { render, staticRenderFns } from "./DatesList.vue?vue&type=template&id=a0e060e0&scoped=true&"
import script from "./DatesList.vue?vue&type=script&lang=js&"
export * from "./DatesList.vue?vue&type=script&lang=js&"
import style0 from "./DatesList.vue?vue&type=style&index=0&id=a0e060e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e060e0",
  null
  
)

export default component.exports